import { Banner } from '@crazyegginc/hatch';

export function DashboardBanner({ children, ...props }) {
  return (
    <Banner className="mx-10 mt-3.75 !w-auto" {...props}>
      {children}
    </Banner>
  );
}
